<template>
	<div class="section-infopartners primary--text mt-10 pb-10">
		<p class="text-h5 font-weight-bold my-5 text-center primary--text">Фотогалерея</p>

		<v-slide-group show-arrows>
			<v-slide-item v-for="(Item, index) in Previews" :key="index">
				<v-dialog v-model="Active[index]" scrollable>
					<template v-slot:activator="{ on, attrs }">
						<v-img v-on="on" v-bind="attrs" :src="Item" max-width="256" height="172" class="mx-1" />
					</template>
					<v-card style="overflow: hidden">
						<v-img :src="Items[currentIndex]" height="100%" contain />
						<v-btn @click="$set(Active, index, false)" color="primary" small absolute top right fab class="mt-8">
							<v-icon>mdi-close</v-icon>
						</v-btn>

						<v-btn 
							v-if="currentIndex > 0"
							@click="currentIndex--" 
							color="primary" 
							absolute 
							top 
							left 
							fab
							:x-large="!$vuetify.breakpoint.xs"
							:small="$vuetify.breakpoint.xs"
							text
							outlined
							:class="$vuetify.breakpoint.xs ? 'ml-n1' : 'ml-4'"
							elevation="0"
							style="top: 50%; transform: translateY(-50%);"
						>
							<v-icon>mdi-chevron-left</v-icon>
						</v-btn>
						
						<!-- Кнопка следующего изображения -->
						<v-btn 
							v-if="currentIndex < Items.length - 1"
							@click="currentIndex++" 
							color="primary" 
							absolute 
							top 
							right 
							fab
							:x-large="!$vuetify.breakpoint.xs"
							:small="$vuetify.breakpoint.xs"
							text
							outlined
							elevation="0"
							:class="$vuetify.breakpoint.xs ? 'mr-n1' : 'mr-12'"
							style="top: 50%; transform: translateY(-50%);"
						>
							<v-icon>mdi-chevron-right</v-icon>
						</v-btn>
					</v-card>
				</v-dialog>
			</v-slide-item>
		</v-slide-group>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
	name: 'SectionGalleryYarmarka',
	data: () => ({
		Active: [] as Array<boolean>,
		currentIndex: 0,
		Items: [
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_01.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_02.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_03.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_04.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_05.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_06.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_07.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_08.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_09.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_010.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_011.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_012.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_013.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_014.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_015.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_016.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_017.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_018.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_019.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_020.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_021.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_022.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_023.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_024.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_025.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_026.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_027.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/Gum_Yarmarka_028.jpg'),
		],
		Previews: [
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_01.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_02.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_03.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_04.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_05.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_06.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_07.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_08.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_09.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_010.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_011.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_012.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_013.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_014.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_015.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_016.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_017.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_018.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_019.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_020.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_021.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_022.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_023.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_024.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_025.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_026.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_027.jpg'),
			require('./../assets/images/gallery/2025/yarmarka/1x1/Gum_Yarmarka_028.jpg'),
		],
	}),
	watch: {
		Active: {
			handler(newVal) {
				// Когда открывается диалог, устанавливаем currentIndex в индекс открытого изображения
				const openIndex = newVal.findIndex((item: any) => item === true);
				if (openIndex !== -1) {
					this.currentIndex = openIndex;
				}
			},
			deep: true
		}
	}
});
</script>
